module.exports = __webpack_public_path__ + "img/025.fb8d5846.png";